// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"68d15f75","297":"bdba3b63","377":"1e0d12bd","643":"d4b728c6"}[chunkId] + ".chunk.js";
};